const mockNetworks = {
  "Brand New": 1,
  "Stingy Folk": 2,
  "Left Out": 3,
  "Everything is done": 4,
  "Parent Net": 5,
  "Logged Out": 6,
  "Having Trouble": 404,
  "Test Net": 7,
  "Australian Network": 81,
  "Needs Stax Migration": 8,
  Brisbane: 49953,
  "Legacy Handlers": 99999,
  // Upgrades tests: networks with specific promo order (component shows first 2 only)
  "Diogenes Party": 99998,
  "Legacy Handlers Library": 99997,
  "Legacy Handlers Reload": 99996,
  "Completion Note Enabled": 9,
  "Family Reg Disabled": 10,
  "Diosync Enabled": 11,
  // Family Registration test networks
  "Non Head of Household": 12,
  "Intro Message Enabled": 13,
  "Unauthenticated User": 14,
  "Closing With Signup": 15,
  "Closing With Website": 16,
  "Closing With Family": 17,
  "Closing With All Actions": 18,
  "Envelopes Enabled": 19,
  "Recurring Gifts Enabled": 20,
  // BackButton navigation test networks
  "Children Multiple": 21, // 2 non-spouse children, no envelopes/recurring
  "Children Single": 22, // 1 child, no envelopes/recurring
  "Children None": 23, // no household members
  "Spouse Only": 24, // only spouse member
  "Both Envelopes And Recurring": 25, // both enabled (envelopes takes priority)
  "Recurring With Children": 26, // recurring + children (recurring takes priority)
  // ClosingScreen title variant test networks
  "Closing First Name Only": 27, // firstName only, no lastName, no household
  "Closing Full Name Solo": 28, // firstName + lastName, no household members
  "Closing No Name": 29, // no firstName, no lastName
  // ClosingScreen closing message test networks
  "Closing With Message": 30, // custom closing message enabled
  "Closing Message Disabled": 31, // closing message disabled but has content
  "Closing Message Empty": 32, // closing message enabled but empty paragraph
  // ClosingScreen close window message test networks
  "Closing No Actions": 33, // all actions disabled, shows "close this window"
  "Closing Message Only": 34, // closing message enabled, no next step buttons
  // NextSteps button edge case test networks
  "Closing Signup Invalid ID": 35, // signup enabled but ID is "0"
  "Closing Signup Disabled": 36, // signup disabled with valid ID
  "Closing Website No Protocol": 37, // website URL without http/https
  "Closing Website Empty Text": 38, // website with empty buttonText (uses URL as fallback)
  "Closing Website Disabled": 39, // website disabled with valid URL
  "Closing Website Empty URL": 40, // website enabled but URL empty
  "Closing Giving Enabled": 41, // manage my giving enabled
  "Closing Giving Disabled": 42, // manage my giving disabled with valid URL
  "Closing Giving Empty URL": 43, // manage my giving enabled but URL empty
  "Video Test": 44, // video action test network
  "FncPromo Test": 55, // fncPromo action test network
  "ArchNYFncPromo Test": 127, // archNYFncPromo action test network
  "No Subtitle Generic": 45, // generic action with no subtitle/description
  "Secular Network": 46, // non-religious network
  // Extended field validation test networks
  "Required Household Field Children": 47, // two children, one required household text field
  "Required Adult Text Field": 48, // one required text field in extendedFieldsAdults
  "Optional Adult Text Field": 49, // one optional text field in extendedFieldsAdults
  "Required Spouse Text Field": 50, // one required text field in extendedFieldsSpouses
  "Required Child Text Field": 51, // one required user-entity text field in extendedFieldsChildren
  "Closing Custom Reg": 52, // custom registration (e.g., RE signups) closing screen
  "Custom Reg Intro": 53, // custom reg + intro message + authenticated user
  "No Payments": 54, // hasFundIt: false, no stax merchant (enrollment not started)
  // Parked up at 300 on purpose. These sit in the middle of the sequential
  // block below, which is still growing — 123 was already taken by "Closing
  // PostReg Verification Required", and since getfamilyregistrationdata routes
  // through _closingNetworks BEFORE _navigationNetworks, the closing seed won
  // and the address field never rendered. Duplicate IDs fail silently here, so
  // keep new ones clear of the counter.
  "Adult Address Field": 300, // one address field in extendedFieldsAdults (used for AddressProfileField verification tests)
  "Adult Address Field Pre-Verified": 301, // same as above, seeded with isVerified=true (phase-cleanup test)
  "Adult Address Three States": 302, // three adult address fields: verified+filled, unverified+filled, empty (storybook only)
  "Registration Drive Test": 303, // registrationDrive action only
  "Registration Drive With FncPromo": 304, // registrationDrive featured, fncPromo collapsed
  "FncPromo Before Registration Drive": 305, // fncPromo featured, registrationDrive collapsed
  "Transfer Same Network": 55,
  "Transfer Single User": 56,
  "Transfer Populated Household": 57,
  "Transfer Lookup Error": 58,
  "Has Membership Status": 59,
  "Legacy Giving Unavailable": 126,
  "Kait Network Override": 47675,
  "Custom Reg Unauth": 60,
  "Family Reg Intl Unauth": 61,
  "Closing PostReg Membership Error": 62,
  "Closing PostReg Container Conflict": 63,
  "Closing PostReg Friendly Conflicts": 64,
  "Closing PostReg Verification Required": 123,
  "Closing LastName Only": 65,
  "Recurring With Existing Gifts": 66,
  "Valid Spouse": 67,
  "Spouse Server Error": 68,
  "Spouse Conflict": 69,
  "Spouse Email Only": 70,
  "Spouse Required Field Filled": 71,
  "Children Server Error": 72,
  "Children Conflict": 73,
  "Child Missing Relationship": 74,
  "Child With Contact": 75,
  "Child Other Relationship": 76,
  "Children Prompt Default": 77,
  "Children Prompt With Existing Child": 78,
  "Contact Valid": 79,
  "Contact Server Error": 80,
  "Contact Server Error No Message": 81,
  "Contact Conflict": 82,
  "Contact Email Only": 83,
  "AdditionalInfo Server Error": 84,
  "AdditionalInfo Server Error No Message": 85,
  "Spouse Remove Error": 86,
  "Children Remove Error": 87,
  "Undefined Relationship": 88,
  "Undefined Relationship No Extended Fields": 89,
  "Undefined Relationship Spouse Candidate": 90,
  "Kait Authenticated": 91,
  "Recurring Screen Blocked": 92,
  "Email Name Fallback": 93,
  "Children With Birthdays": 94,
  "Spouse With Saved Child": 95,
  "Membership Status Fresh User": 96,
  "Child Proxy On": 98,
  "Child Contact Disabled": 99,
  "Spouse With Unpopulated Date EFR": 97,
  "Child Without Spouse Decision": 100,
  "AdditionalInfo With Saved Spouse": 101,
  "Contact CA": 102,
  "Contact No Country Code": 103,
  "Emergency Contact User Field": 104,
  "Emergency Contact Spouse Field": 105,
  "Emergency Contact Child Field": 106,
  "Medical Allergy User Field": 107,
  "Medical Allergy Spouse Field": 108,
  "Medical Allergy Child Field": 109,
  "Address Spouse Field": 110,
  "Address Child Field": 111,
  "Required Spouse Address Field": 112,
  "Required Spouse Number Field": 113,
  "Required Spouse EmergencyContact Field": 114,
  "Required Spouse MedicalAllergy Field": 115,
  "Required Spouse File Field": 116,
  "Required Spouse Picker Field": 117,
  "Required Spouse Date Field": 118,
  "Contact Valid With Adult Field": 119,
  "Closing With Family And Adult Field": 120,
  "Recurring And Envelopes No Existing Gifts": 121,
  "Valid Spouse No Adult Fields": 122,
  // Giving default-experience test networks (can view legacy; differ on the config default)
  "Default New Giving On": 200,
  "Default New Giving Off": 201,
  // Test Net as a parent network, for code that branches on `isParent`
  "Parent Test Net": 202,
  // Diocese with FNC (unlike "Parent Net", which renders the FNC splash)
  "Parent Net With FNC": 130,
  // Same, but the backend says no to Add to Parish (data copy off at the diocese, or household copy switched off)
  "Parent Net With FNC No Data Copy": 131,
};

const networkMetadata = (networkId) => {
  switch (networkId) {
    // network 1 is brand new. No features, no free trials used.
    case mockNetworks["Brand New"]:
      return {
        success: true,
        hasUsedFPTrial: false,
        hasFNP: false,
        hasFNC: false,
        showPeopleSplash: true,
        showCompleteSplash: true,
        hasSignupsProfileFields: false,
        hasManageMyGivingPage: false,
        canStax: false,
        hasContactUs: false,
        canContactUs: true,
        networkName: "The Wooly Bully",
        networkID: networkId,
      };
    // network 2 is stingy but open minded. All free stuff was used long ago, but network flags are aways on.
    case mockNetworks["Stingy Folk"]:
      return {
        success: true,
        hasUsedFPTrial: true,
        hasFNP: false,
        hasFNC: false,
        hasSignupsProfileFields: true,
        networkID: networkId,
        hasContactUs: true,
        canContactUs: true,
        hasSmartGroups: true,
        hasPrayerRequests: false,
      };
    // network 3 wants all the things but is often denied. They have everything possible, but no network flags.
    case mockNetworks["Left Out"]:
      return {
        success: true,
        hasUsedFPTrial: true,
        hasFNP: true,
        hasFNC: true,
        hasFundIt: false,
        hasSignupsProfileFields: false,
        hasContactUs: false,
        canContactUs: false,
        networkID: networkId,
      };
    case mockNetworks["No Payments"]:
      return {
        success: true,
        hasFundIt: false,
        networkID: networkId,
      };
    // network 404 is having lots of trouble.
    case mockNetworks["Having Trouble"]:
      return {
        success: true,
        networkID: networkId,
        canStax: true,
        networkName: "Having Trouble Network",
      };
    case mockNetworks["Contact CA"]:
      return {
        success: true,
        address: {
          street: "123 Maple St",
          city: "Ottawa",
          state: "ON",
          zip: "K1A 0A9",
          countryCode: "CA",
        },
        hasFNP: true,
        hasFNC: true,
        hasSignupsProfileFields: true,
        hasUsedFPTrial: true,
        hasFundIt: true,
        hasManageMyGivingPage: true,
        canHaveFundIt: true,
        isApp: false,
        userId: 2,
        hasAddOnGifts: true,
        networkName: "The Wooly Bully",
        canStax: true,
        isCatholic: true,
        networkID: networkId,
      };
    case mockNetworks["Contact No Country Code"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        hasSignupsProfileFields: true,
        hasUsedFPTrial: true,
        hasFundIt: true,
        hasManageMyGivingPage: true,
        canHaveFundIt: true,
        isApp: false,
        userId: 2,
        hasAddOnGifts: true,
        networkName: "The Wooly Bully",
        canStax: true,
        isCatholic: true,
        networkID: networkId,
      };
    case mockNetworks["Australian Network"]:
    case mockNetworks["Family Reg Intl Unauth"]:
    case mockNetworks["Spouse Email Only"]:
    case mockNetworks["Contact Email Only"]:
      return {
        success: true,
        address: {
          countryCode: "AU",
        },
        hasFNP: true,
        hasFNC: true,
        hasSignupsProfileFields: true,
        hasUsedFPTrial: true,
        hasFundIt: true,
        hasManageMyGivingPage: true,
        canHaveFundIt: true,
        isApp: false,
        userId: 2,
        hasAddOnGifts: true,
        networkName: "The Wooly Bully",
        canStax: true,
        isCatholic: false,
        networkID: networkId,
      };
    case mockNetworks["Default New Giving On"]:
      return {
        success: true,
        canViewLegacyGivingUI: true,
        defaultToNewGivingEnabled: true,
        networkID: networkId,
      };
    case mockNetworks["Default New Giving Off"]:
      return {
        success: true,
        canViewLegacyGivingUI: true,
        defaultToNewGivingEnabled: false,
        networkID: networkId,
      };
    case mockNetworks["Legacy Giving Unavailable"]:
      return {
        success: true,
        canViewLegacyGivingUI: false,
        defaultToNewGivingEnabled: false,
        networkID: networkId,
      };
    case mockNetworks["Secular Network"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        hasSignupsProfileFields: true,
        networkName: "Secular Org",
        isCatholic: false,
        isNonReligious: true,
        networkID: networkId,
      };
    case mockNetworks["Parent Net"]:
      return {
        success: true,
        showCompleteSplash: true,
        hasChildNetsWithFNC: true,
        isParent: true,
        networkID: networkId,
      };
    case mockNetworks["Parent Net With FNC"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        isParent: true,
        hasDiosync: true,
        canAddToParish: true,
        networkName: "Diocese of Mock",
        networkID: networkId,
      };
    case mockNetworks["Parent Net With FNC No Data Copy"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        isParent: true,
        hasDiosync: true,
        canAddToParish: false,
        networkName: "Diocese of Mock",
        networkID: networkId,
      };
    // Network with family registration disabled
    case mockNetworks["Family Reg Disabled"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        networkName: "Family Reg Disabled",
        networkID: networkId,
        hasDiosync: false,
      };
    // Network with Diosync enabled (locks family registration)
    case mockNetworks["Diosync Enabled"]:
      return {
        success: true,
        hasFNP: true,
        hasFNC: true,
        networkName: "Diosync Network",
        networkID: networkId,
        hasDiosync: true,
      };
    case mockNetworks["Parent Test Net"]:
      return {
        ...networkMetadata(mockNetworks["Test Net"]),
        isParent: true,
        networkID: networkId,
      };
    // all other networks are humming along (use 7 since that's a nice holy number)
    case mockNetworks["Needs Stax Migration"]:
    case mockNetworks["Test Net"]:
    case mockNetworks["Legacy Handlers"]:
    default:
      return {
        success: true,
        address: {
          street: "123 Main St",
          city: "Capital City",
          state: "WA",
          zip: "12345",
          countryCode: "US",
        },
        everyoneGroupID: 10,
        hasFNP: true,
        hasFNC: true,
        hasSignupsProfileFields: true,
        hasUsedFPTrial: true,
        hasFundIt: true,
        hasManageMyGivingPage: true,
        canHaveFundIt: true,
        isApp: false,
        userId: 2,
        hasAddOnGifts: true,
        networkName: "The Wooly Bully",
        canStax: true,
        isCatholic: true,
        hasContactUs: true,
        canContactUs: true,
        hasPrayerRequests: true,
        hasSmartGroups: true,
        canAddSmartGroups: true,
        networkID: networkId,
        networkLogo: "//this/does/not/actually/exist.png",
      };
  }
};
export { mockNetworks };
export default networkMetadata;
